import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import RouteNameConstants from "../constants/route-name-constants";
import { AuthService } from "./auth.service";

@Injectable()
export class CountryAdminAuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate() {
    return this.authService.isCountryAdminAsync().then((x) => {
      if (!x) {
        this.router.navigate([RouteNameConstants.NO_ACCESS]);
      }
    });
  }
}
